// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2HdGc","insightsList":"newBusinessInsightsMenu_insightsList__2Tu6C","active":"newBusinessInsightsMenu_active__TFTBH"};